import MicrophoneSvg from './MicrophoneIcon.svg?react'

import styles from '@/pages/app/Usage/styles.module.scss'

const MicrophoneIcon = () => <MicrophoneSvg className={styles.icon} />

export default MicrophoneIcon
